import {ref} from 'vue'
import {debounce} from 'throttle-debounce'

export const useGetData = (api, params, appData) => {
    const isLoading = ref(false)
    const errorMessage = ref('')
    const data = ref(appData)

    const fetcher = () => {
        isLoading.value = true

        const request = debounce(300, async () => {
            try {
                data.value = await api(params.value)
            }
            catch {
                errorMessage.value = 'Произошла ошибка попробуйте еще раз'
                // data.value = null
            }
            finally {
                isLoading.value = false
            }
        })

        request()
    }

    return {data, fetcher, isLoading, errorMessage}
}
